import api, { queryClient } from "@app/config/api/api";
import { notifications } from "@lib/notification/notification";

export const apiKeysQueryOptions = api.queryOptions("get", "/auth/keys/", {
  queryKey: ["keys"]
});

export const useApiKeys = (includeRevoked: boolean = false) =>
  api.useQuery("get", "/auth/keys/", {
    params: { query: { include_revoked: includeRevoked } },
    queryKey: ["keys", { includeRevoked }]
  });

export const useCreateApiKey = () =>
  api.useMutation("post", "/auth/keys/", {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: apiKeysQueryOptions.queryKey
      });
      notifications.success("API key created successfully");
    }
  });

export const useRevokeApiKey = () =>
  api.useMutation("post", "/auth/keys/{api_key_id}/revoke", {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: apiKeysQueryOptions.queryKey
      });
      notifications.success("API key revoked successfully");
    }
  });
